module.exports = "//d274d294w9cx2v.cloudfront.net/dffb2f75a857106ec1477252315acf2bb92d9ee5/images/payPalBadge.png";